module.exports = __webpack_public_path__ + "img/mollie.a6406f9.svg";